/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Action_RevertedInputs */



/**
* | output |
* | --- |
* | "Action could not be saved — reverted to the previous state." |
*
* @param {Tournament_Action_RevertedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_action_reverted = /** @type {((inputs?: Tournament_Action_RevertedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Action_RevertedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'action n'a pas pu être enregistrée — retour à l'état précédent.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La acción no se pudo guardar — se revirtió al estado anterior.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A ação não pôde ser salva — revertido ao estado anterior.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile salvare l'azione — ripristinato allo stato precedente.")
	return /** @type {LocalizedString} */ ("Action could not be saved — reverted to the previous state.")
});